<div class="item-list">
  <div>
    <div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-11 col-md-11">
            <div class="row mb-2">
              <div class="col-sm-4 col-md-4">
                <select [(ngModel)]="detailsType" name="detailsTypeDropdown" class="form-control"
                  #detailsTypeDropdown="ngModel" required>
                  <option *ngFor="let type of detailsTypes" value="{{ type.value }}">{{ type.label }}</option>
                </select>
              </div>
            </div>
            <div class="row mb-2 percent-details">
              <div *ngIf="isDetailsTypeOther; else detailsTypePercentOff" class="col-sm-6 col-md-6">
                <input [(ngModel)]="slot.details" name="details" class="form-control" #details="ngModel" maxlength="20">
                <small class="text-danger" *ngIf="(details.touched || details.dirty) && !details.valid">
                  Details are limited to 20 characters.
                </small>
              </div>
              <ng-template #detailsTypePercentOff>
                <div class="col-sm-2 col-md-2">
                  <input [(ngModel)]="percentOff" name="percentOffField" class="form-control" #percentOffField="ngModel"
                    type="number" min="0" max="100">
                  <small class="text-danger"
                    *ngIf="(percentOffField.touched || percentOffField.dirty) && !!percentOff && (percentOff < 0 || percentOff > 100)">
                    Percentage should be between 0 and 100.
                  </small>
                </div>
                <div class="col-sm-2 col-md-2">
                  % off
                </div>
                <div class="col-sm-4 col-md-4">
                  <select [(ngModel)]="discountTarget" name="discountTargetDropdown" class="form-control"
                    #discountTargetDropdown="ngModel" required>
                    <option *ngFor="let target of discountTargets" value="{{ target.value }}">{{ target.label }}
                    </option>
                  </select>
                </div>
              </ng-template>
            </div>
            <div class="row">
              <div class="col-sm-4 col-md-4">
                <select [(ngModel)]="slot.type" name="slotType" class="form-control" #type="ngModel" required>
                  <option *ngFor="let type of slotTypes" value="{{ type.value }}">{{ type.label }}</option>
                </select>
                <small class="text-danger" *ngIf="(type.touched || type.dirty) && !type.valid">
                  Slot type is required.
                </small>
              </div>
              <div class="col-sm-4 col-md-4">
                <ch-datetime-picker [value]="slot.startTime" (onChange)="updateStartTime($event)"
                  id="availability-item-start-time-picker"></ch-datetime-picker>
              </div>
              <div class="col-sm-4 col-md-4">
                <ch-datetime-picker [value]="slot.endTime" (onChange)="updateEndTime($event)"
                  id="availability-item-end-time-picker"></ch-datetime-picker>
              </div>
            </div>
          </div>
          <div class="col-sm-1 col-md-1"></div>
        </div>
      </div>
    </div>
    <div class="availability-slot-checkbox">
      <ch-checkbox-group (selected)="daySelected($event)" [values]="daysValues()"
        multiselect="true"></ch-checkbox-group>
    </div>
    <div class="availability-slot-terms">
      <div class="row">
        <div class="col-sm-12">
          <label>Additional Terms or Conditions</label>
        </div>
      </div>
      <div *ngFor="let term of slot.termsAndConditions; let i = index; trackBy: trackByIndex" class="row mb-2">
        <div class="col-sm-10">
          <input [ngModel]="slot.termsAndConditions[i]"
                 (ngModelChange)="updateTermsAndConditionsItem(i, $event)"
                 [name]="'termsAndConditions-' + i"
                 class="form-control"
                 placeholder="Enter terms or conditions">
        </div>
        <div class="col-sm-2">
          <button type="button"
                  class="btn btn-danger btn-sm"
                  (click)="removeTermsAndConditionsItem(i)"
                  aria-label="Remove term">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <button type="button"
                  class="btn btn-success btn-sm"
                  (click)="addTermsAndConditionsItem()"
                  aria-label="Add term">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <button type="button" class="btn btn-danger list-item-close" aria-label="Close" (click)="deleteSlot()">
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/availability-item/availability-item.component.html